<mat-checkbox class="w-100 mb-3" matInput [formControlName]="fieldName">
    {{ label | translate }}
</mat-checkbox>
